import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
        <i className="ri-compass-3-line text-2xl" aria-hidden="true"></i>
      </span>
      <h1 className="mt-5 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        这个页面还没有内容
      </h1>
      <p className="mt-2 font-mono text-xs text-foreground-500 md:text-sm">{location.pathname}</p>
      <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
        链接可能已失效或地址有误。回到首页，可以继续查看灵灵事件的时间线、回应与辟谣分析。
      </p>
      <Link
        to="/"
        className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
      >
        <i className="ri-arrow-left-line" aria-hidden="true"></i>
        返回首页
      </Link>
    </div>
  );
}